import { action } from 'typesafe-actions';
import {
  SETTINGS_FAILURE,
  SETTINGS_REQUEST,
  SETTINGS_SUCCESS,
} from '../../constants/settings';

export const settingsRequestAction = () => action(SETTINGS_REQUEST);
export const settingsSuccessAction = (data: any) =>
  action(SETTINGS_SUCCESS, data);
export const settingsFailureAction = (e: any) => action(SETTINGS_FAILURE, e);

export const settingsActions = {
  settingsRequestAction,
  settingsSuccessAction,
  settingsFailureAction,
};
